import ColorOfTasks from "@/components/internal_requests/KPI/TasksReport/ColorOfTasks";
import ImagePerson from "@/components/functionals/ImagePerson";

export default [
  {
    prop: "ID",
    label: "No. ",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: ColorOfTasks
  },
  {
    prop: "Name",
    label: "Descripción",
    "min-width": 130,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "PersonInfo.Name",
    label: "Responsable",
    "min-width": 130,
    sortable: true,
    formatter: ImagePerson,
    attrs: {
      imgKey: "PersonInfo.PhotoPath"
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "CreadorBy",
    label: "Creado Por",
    "min-width": 150,
    sortable: true,
    formatter: ImagePerson,
    attrs: {
      imgKey: "CreadorPhoto"
    }
  },
  {
    prop: "StatusName",
    label: "Estado",
    "min-width": 130,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "TimeOntask",
    label: "Tiempo en Horas",
    "min-width": 150,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "DelayedDays",
    label: "Rettraso",
    "min-width": 100,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Monday",
    label: "Lunes",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: ColorOfTasks
  },
  {
    prop: "Tuesday",
    label: "Martes",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: ColorOfTasks
  },
  {
    prop: "Wednesday",
    label: "Miercoles",
    "min-width": 110,
    sortable: true,
    align: "center",
    formatter: ColorOfTasks
  },
  {
    prop: "Thursday",
    label: "Jueves",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: ColorOfTasks
  },
  {
    prop: "Friday",
    label: "Viernes",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: ColorOfTasks
  },
  {
    prop: "Saturday",
    label: "Sábado",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: ColorOfTasks
  }
];

export const TaskReportActions = (thiss) => [
  {
    icon: "el-icon-view",
    label: "Ver Detalle",
    command: "view_task"
  },
  // {
  //   icon: "el-icon-edit",
  //   label: "Editar Tarea",
  //   command: "edit_task"
  // },

  {
    icon: "el-icon-circle-close",
    label: "Cerrar",
    command: "close_task",
    condition: (row) => {
      return !row.IsItClosed;
    }
  },
  {
    icon: "el-icon-refresh",
    label: "Re-Abrir",
    command: "reopen-task",
    condition: (row) =>
      thiss.AmIsupervisor &&
      row.IsItClosed &&
      String(row.ID || "").startsWith("T")
  },
  {
    icon: "el-icon-time",
    label: "Editar Tiempo",
    command: "edit_task_time",
    condition: () => thiss.AmIsupervisor
  },
  {
    icon: "el-icon-edit",
    label: "Editar Responsable",
    command: "edit_responsible",
    condition: (row) => !row.IsItClosed && thiss.AmIsupervisor // && false
  },
  {
    icon: "el-icon-date",
    label: "Editar Fecha de Compromiso de Tarea",
    command: "edit_task_due_date",
    condition: (row) =>
      !row.IsItClosed &&
      thiss.AmIsupervisor &&
      (row.ID.startsWith("T") || row.ID.startsWith("SE"))
  },
  {
    icon: "el-icon-edit",
    label: "Editar Tarea",
    command: "edit_task",
    condition: () => thiss.AmIsupervisor && thiss.IsInRole("CEO")
  },
  // ,
  // {
  //   icon: "el-icon-refresh",
  //   label: "Ordenar todas las Tareas",
  //   command: "order_tasks"
  //   //condition: (row) => !row.IsItClosed && thiss.AmIsupervisor
  // },
  {
    icon: "el-icon-delete",
    label: "Eliminar",
    command: "delete_task",
    condition: (row) => !row.IsItClosed && thiss.AmIsupervisor
  },
  {
    icon: "el-icon-date",
    label: "Reasignar Fecha de Cierre",
    command: "reassign_close_date",
    condition: (row) =>
      row.IsItClosed && thiss.AmIsupervisor && row.ID.startsWith("T")
  }
];
